import { render, staticRenderFns } from "./WTable2.vue?vue&type=template&id=a36cded8"
import script from "./WTable2.vue?vue&type=script&lang=js"
export * from "./WTable2.vue?vue&type=script&lang=js"
import style0 from "./WTable2.vue?vue&type=style&index=0&id=a36cded8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports